import { useDestinationsInAddress } from '@/abilities/useDestinationsInAddress';
import { createDestinationRouteCondition } from '@/abilities/routeCondition';
import { useCompanyBankFeedAccess } from '@/abilities/companyBankFeed/useCompanyBankFeedAccess';
import {
  isCompanyBankFeedDestination,
  type CompanyBankFeedDestinationKey,
} from '@/abilities/companyBankFeed/vocabulary';

export const companyBankFeedRoute = createDestinationRouteCondition(useCompanyBankFeedAccess);

// From the page down to its tab; empty when no Bank Feed route declares the address.
export const useCompanyBankFeedDestinationsInAddress = (): CompanyBankFeedDestinationKey[] =>
  useDestinationsInAddress(isCompanyBankFeedDestination);
